//权利人表格配置
const qlrTable = [
  {
    label: '姓名',
    prop: 'qlrmc',
    width: '150px'
  },
  {
    label: '证件种类',
    prop: 'zjzl',
    type: 'dic'
  },
  {
    label: '证件号',
    prop: 'zjh',
    width: '200px'
  },
  {
    label: '联系电话',
    prop: 'dh'
  },
  {
    label: '共有方式',
    prop: 'gyfs',
    type: 'dic'
  },
  {
    label: '权利比例',
    prop: 'qlbl'
  }
];
//义务人表格配置
const ywrTable = [
  {
    label: '姓名',
    prop: 'ywrmc',
    width: '150px'
  },
  {
    label: '证件种类',
    prop: 'zjzl',
    type: 'dic'
  },
  {
    label: '证件号',
    prop: 'zjh',
    width: '200px'
  },
  {
    label: '联系电话',
    prop: 'dh'
  },
  {
    label: '共有方式',
    prop: 'gyfs',
    type: 'dic'
  },
  {
    label: '权利比例',
    prop: 'qlbl'
  }
];
//债务人表格配置
const zwrTable = [
  {
    label: '姓名',
    prop: 'ywrmc',
    width: '150px'
  },
  {
    label: '证件种类',
    prop: 'zjzl',
    type: 'dic'
  },
  {
    label: '证件号',
    prop: 'zjh',
    width: '200px'
  },
  {
    label: '联系电话',
    prop: 'dh'
  },
  {
    label: '借款方式',
    prop: 'jkfs',
    formatter: (row) => {
      if (row.gyfs === '0') {
        return `<span>单独借款</span>`;
      } else {
        return `<span>共同借款</span>`;
      }
    }
  },
  {
    label: '权利比例',
    prop: 'qlbl'
  }
];
// 权利信息表格配置
const qlxxTable = [
  {
    label: '不动产权证号',
    prop: 'bdcqzh'
  },
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  },
  {
    label: '房屋交易价格(万元)',
    prop: 'fwjyjg'
  }
];
//抵押首次不动产表格
const dyscqlxxTable = [
  {
    label: '不动产权证号',
    prop: 'bdcqzh'
  },
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  }
];
// 权利信息表格配置
const ysqlxxTable = [
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  },
  {
    label: '房屋交易价格(万元)',
    prop: 'fwjyjg'
  }
];
// 预告买卖流程，预告买卖注销、预告买卖+预告抵押流程去掉“房产交易价格”
const ygqlxxTable = [
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  }
];
const ygqlxxTableNew = [
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'ycjzmj'
  },
  {
    label: '房屋用途',
    prop: 'fwytShow',
    formatter: (row) => {
      if(!row.fwyt){
        row.fwyt = '10';//房屋用途给默认值
      }
      let url = window.location.href;
      const dic = url.indexOf('manager') < 0 ? localStorage.IEBDC_DIC_DATA : localStorage.DIC_DATA;
      const allDic = JSON.parse(dic).dic;
      const dicArr = allDic.find((item) => {
        return item.label === '房屋用途';
      });
      let fwytShowList = dicArr.childrens.find((item) => {
        return item.value == row.fwyt
      })
      return fwytShowList ? fwytShowList.label : row.fwyt
    }
  }
];
const zbwqlxxTableNew = [
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  },
  {
    label: '房屋用途',
    prop: 'fwytShow',
    formatter: (row) => {
      if(!row.fwyt){
        row.fwyt = '10';//房屋用途给默认值
      }
      let url = window.location.href;
      const dic = url.indexOf('manager') < 0 ? localStorage.IEBDC_DIC_DATA : localStorage.DIC_DATA;
      const allDic = JSON.parse(dic).dic;
      const dicArr = allDic.find((item) => {
        return item.label === '房屋用途';
      });
      let fwytShowList = dicArr.childrens.find((item) => {
        return item.value == row.fwyt
      })
      return fwytShowList ? fwytShowList.label : row.fwyt
    }
  }
];
// 权利信息表格配置
const fwscQlxxTable = [
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '不动产面积(㎡)',
    prop: 'fwcqmj'
  }
];
// 权利信息表格配置(N200111，N100303)
const tddyqQlxxTable = [
  {
    label: '土地不动产权证号',
    prop: 'bdcqzh'
  },
  {
    label: '不动产单元号',
    prop: 'bdcdyh'
  },
  {
    label: '不动产坐落',
    prop: 'zl',
    width: '250px'
  },
  {
    label: '土地使用权面积(㎡)',
    prop: 'tdsyqmj'
  }
];
//家庭组表格配置
const familyGroupTable = [
  {
    label: '姓名',
    prop: 'name'
  },
  {
    label: '家庭成员关系',
    prop: 'familyRelationshipEnum',
    type: 'dic'
  },
  {
    label: '证件种类',
    prop: 'zjzl',
    type: 'dic'
  },
  {
    label: '证件号码',
    prop: 'zjh',
    width: '200px'
  },
  {
    label: '性别',
    prop: 'xb',
    type: 'dic'
  }
];
export default {
  qlrTable,
  ywrTable,
  zwrTable,
  qlxxTable,
  ysqlxxTable,
  dyscqlxxTable,
  fwscQlxxTable,
  familyGroupTable,
  tddyqQlxxTable,
  ygqlxxTable,
  ygqlxxTableNew,
  zbwqlxxTableNew
};
